/**
 * Default App prefix
 */
export const APP_PREFIX = 'mo';
